"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _transition = _interopRequireDefault(require("../helpers/transition"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  &.custom-checkbox {\n    ", ";\n    ", ";\n  }\n\n  &.custom-checkbox.withoutLabel {\n    ", ";\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Checkbox = (0, _styledComponents.default)(_core.Checkbox)(_templateObject(), function (props) {
  return props.color && !props.icon && props.color === 'primary' && "\n    position:relative;\n    input {\n      z-index: 1;\n    }\n    &::after{\n      border: 2px solid transparent;\n      transition: ".concat((0, _transition.default)(props.theme.transitions).join(','), ";\n    }\n    &:hover::after, &:focus::after {\n      display: block;\n      content: '';\n      box-sizing: content-box;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%,-50%);\n      height: 14px;\n      width: 14px;\n      border: 2px solid ").concat(props.theme.palette.primary.main, ";\n      border-radius: 3px;\n    }\n  ");
}, function (props) {
  return "\n      color:".concat(props.theme.palette.grey[800], ";\n      height: 36px;\n      width: 40px;\n      border: 1px solid ").concat(props.theme.palette.grey[400], ";\n      border-radius: 2px;\n      box-sizing: border-box;\n      transition: ").concat((0, _transition.default)(props.theme.transitions).join(','), ";\n      &:hover {\n        background-color: ").concat(props.theme.palette.getLighterColor(props.theme.palette.primary.main), ";\n        border: 2px solid ").concat(props.theme.palette.primary.main, ";\n      }\n    ");
}, function (props) {
  return props.checked && props.checked === true && "\n      width: 56px;\n      position: relative;\n      border: 2px solid ".concat(props.theme.palette.primary.main, ";\n      background-color: ").concat(props.theme.palette.getLighterColor(props.theme.palette.primary.light), "\n      \n      .custom-checkbox-checked span {\n        transform: translate(0,-50%);\n        position: absolute;\n        top: 50%;\n      }\n      .custom-checkbox-checked span:first-of-type {\n        left: 8px;\n      }\n      .custom-checkbox-checked span:nth-of-type(2) {\n        right: 8px;\n        font-size: ").concat(props.theme.typography.h3.fontSize, ";\n      }\n    ");
}, function (props) {
  return "\n      color:".concat(props.theme.palette.grey[800], ";\n      height: 36px;\n      width: 40px;\n      border: 1px solid ").concat(props.theme.palette.grey[400], ";\n      border-radius: 2px;\n      box-sizing: border-box;\n      transition: ").concat((0, _transition.default)(props.theme.transitions).join(','), ";\n      &:hover {\n        background-color: ").concat(props.theme.palette.getLighterColor(props.theme.palette.primary.main), ";\n        border: 2px solid ").concat(props.theme.palette.primary.main, ";\n      }\n    ");
}, function (props) {
  return props.checked && props.checked === true && "\n      width: 40px;\n      position: relative;\n      border: 2px solid ".concat(props.theme.palette.primary.main, ";\n      background-color: ").concat(props.theme.palette.getLighterColor(props.theme.palette.primary.light), "\n      \n    ");
});
/** @component */

var _default = Checkbox;
exports.default = _default;